
var id = "approve-hover";
var markup = "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 240 240\" id=\"approve-hover\">\n<style type=\"text/css\">\n\t#approve-hover .st0{fill:#054496;}\n</style>\n<g>\n\t<path class=\"st0\" d=\"M155.36,84.64l-49.5,49.5l-21.21-21.21c-3.91-3.91-10.24-3.91-14.14,0l0,0c-3.91,3.91-3.91,10.24,0,14.14\n\t\tl28.28,28.28c3.91,3.91,10.24,3.91,14.14,0l0,0l56.57-56.57c3.91-3.91,3.91-10.24,0-14.14C165.59,80.74,159.26,80.74,155.36,84.64z\n\t\t\" />\n\t<path class=\"st0\" d=\"M120,20C64.77,20,20,64.77,20,120s44.77,100,100,100c55.23,0,100-44.77,100-100S175.23,20,120,20z M120,200\n\t\tc-44.18,0-80-35.82-80-80s35.82-80,80-80c44.18,0,80,35.82,80,80S164.18,200,120,200z\" />\n</g>\n</symbol>";
(function injectSprite() {
  if (typeof document === 'undefined') return;
  var SPRITE_ID = '__UMI_SVG_SPRITE__';
  function ensure() {
    var root = document.getElementById(SPRITE_ID);
    if (!root) {
      root = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
      root.setAttribute('id', SPRITE_ID);
      root.setAttribute('aria-hidden', 'true');
      root.setAttribute('style', 'position:absolute;width:0;height:0;overflow:hidden');
      var parent = document.body || document.documentElement;
      parent.insertBefore(root, parent.firstChild);
    }
    if (document.getElementById(id)) return;
    try {
      root.insertAdjacentHTML('beforeend', markup);
      return;
    } catch (e) {}
    try {
      var doc = new DOMParser().parseFromString(
        '<svg xmlns="http://www.w3.org/2000/svg">' + markup + '</svg>',
        'image/svg+xml'
      );
      var node = doc.querySelector('symbol');
      if (node) root.appendChild(document.importNode(node, true));
    } catch (e2) {}
  }
  if (document.body || document.documentElement) ensure();
  else document.addEventListener('DOMContentLoaded', ensure);
})();
module.exports = id;
module.exports.default = id;
module.exports.id = id;
